/**
 * User Lists Components
 * 
 * Consolidated user list pages that share the same MediaListPage base:
 * - Favorites
 * - Watchlist  
 * - Watched
 */

import MediaListPage from './media-list-page';
import { useAuth } from '../contexts/auth-context';
import Icon from './icon';

/**
 * Favorites - User's favorite movies and TV shows
 */
export function Favorites() {
  const { user, removeFromFavorites } = useAuth();

  const getFavorites = () => {
    return user?.favorites || [];
  };

  const icon = <Icon name="heart-filled" className="w-6 h-6 text-white" />;

  return (
    <MediaListPage
      title="Mėgstamiausi"
      subtitle="Jūsų mėgstamiausi filmai ir TV serialai"
      icon={icon}
      emptyMessage="Dar nepridėjote jokių filmų ar serialų į mėgstamiausius. Pradėkite tyrinėti ir pridėkite tuos, kurie jums patinka!"
      getUserMediaItems={getFavorites}
      removeFromUserList={removeFromFavorites}
    />
  );
}

/**
 * Watchlist - Movies and TV shows user plans to watch
 */
export function Watchlist() {
  const { user, removeFromWatchlist } = useAuth();

  const getWatchlist = () => {
    return user?.watchlist || [];
  };

  const icon = <Icon name="clipboard" className="w-6 h-6 text-white" />;

  return (
    <MediaListPage
      title="Žiūrėjimo sąrašas"
      subtitle="Filmai ir TV serialai, kuriuos planuojate žiūrėti"
      icon={icon}
      emptyMessage="Jūsų žiūrėjimo sąrašas tuščias. Pridėkite filmų ir serialų, kuriuos norėtumėte žiūrėti vėliau!"
      getUserMediaItems={getWatchlist}
      removeFromUserList={removeFromWatchlist}
    />
  );
}

/**
 * Watched - Movies and TV shows user has already watched
 */
export function Watched() {
  const { user, removeFromWatched } = useAuth();

  const getWatched = () => {
    return user?.watched || [];
  };

  const icon = <Icon name="eye" className="w-6 h-6 text-white" />;

  return (
    <MediaListPage
      title="Peržiūrėti"
      subtitle="Filmai ir TV serialai, kuriuos jau peržiūrėjote"
      icon={icon}
      emptyMessage="Dar nepažymėjote jokių filmų ar serialų kaip peržiūrėtų. Pradėkite žiūrėti ir pažymėkite tuos, kuriuos jau matėte!"
      getUserMediaItems={getWatched}
      removeFromUserList={removeFromWatched}
    />
  );
}

// Default export for convenience
const UserLists = { Favorites, Watchlist, Watched };
export default UserLists;
